import React from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { education } from "../constants/index";
import { SectionWrapper } from "../hoc/index";
import { fadeIn, textVariant } from "../utils/motion";

const EducationCard = ({ item, index, isLast }) => (
  <motion.div
    variants={fadeIn("right", "spring", index * 0.3, 0.75)}
    className={`relative pl-12 md:pl-16 ${isLast ? "pb-0" : "pb-12"}`}
  >
    <span
      className="absolute left-[11px] md:left-[15px] top-0 w-4 h-4 md:w-5 md:h-5 rounded-full border-[3px] border-[#915eff] bg-[#0A0A0A] z-10"
      aria-hidden="true"
    />
    {!isLast && (
      <span
        className="absolute left-[18px] md:left-[22px] top-4 md:top-5 bottom-0 w-[2px] bg-gradient-to-b from-[#915eff] to-[#3b82f6]"
        aria-hidden="true"
      />
    )}

    <div className="absolute left-0 top-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#0A0A0A] border-[3px] border-[#915eff] flex items-center justify-center overflow-hidden">
      {item.icon ? (
        <img
          src={item.icon}
          alt={item.school}
          className="w-[60%] h-[60%] object-contain"
        />
      ) : (
        <span className="text-[#915eff] text-xs md:text-sm font-bold">
          {item.badge}
        </span>
      )}
    </div>

    <p className="text-secondary text-[14px] font-medium mb-2">{item.date}</p>

    <div
      className="bg-[#0A0A0A] p-5 md:p-6 rounded-xl border border-transparent hover:bg-[#0F0F0F] transition-colors duration-300"
      style={{
        borderImage:
          "linear-gradient(to right, rgb(147, 51, 234), rgb(59, 130, 246)) 1",
      }}
    >
      <h3 className="text-white text-[22px] md:text-[24px] font-bold">
        {item.degree}
      </h3>
      <p className="text-secondary text-[16px] font-semibold mt-1">
        {item.school}
      </p>
      <p className="text-white/70 text-[14px] mt-1">{item.location}</p>
      <p className="text-white/90 text-[14px] mt-4 font-medium">{item.grade}</p>

      <ul className="mt-5 list-disc ml-5 space-y-2">
        {item.highlights.map((highlight) => (
          <li
            key={highlight}
            className="text-white/90 text-[14px] pl-1 tracking-wider"
          >
            {highlight}
          </li>
        ))}
      </ul>
    </div>
  </motion.div>
);

const Education = () => {
  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}>Academic background</p>
        <h2 className={styles.sectionHeadText}>Education</h2>
      </motion.div>

      <div className="mt-20 max-w-3xl mx-auto">
        {education.map((item, index) => (
          <EducationCard
            key={item.degree}
            item={item}
            index={index}
            isLast={index === education.length - 1}
          />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Education, "education");
